import heroCardTextLocation from './heroCardTextLocation.js';
import layoutStyle from './layoutStyle.js';
import variationHandler from './variations/variationHandler.js';
var handler = function handler(textLocation, textAlignment, textPlacement, textVerticalAlignment, predefinedVariation) {
  if (textLocation) {
    return heroCardTextLocation(textLocation);
  }
  var alignment = variationHandler(predefinedVariation);
  if (textAlignment) {
    alignment.getAlignment = layoutStyle({
      textAlignment: textAlignment
    }).getAlignment;
  }
  if (textPlacement) {
    alignment.getGridAlignment = layoutStyle({
      textPlacement: textPlacement
    }).getGridAlignment;
  }
  if (textVerticalAlignment) {
    alignment.getVerticalAlignment = layoutStyle({
      textVerticalAlignment: textVerticalAlignment
    }).getVerticalAlignment;
  }
  return alignment;
};

/**
 * Handles the alignment of the card based on the provided parameters.
 * textLocation has priority
 * If textLocation is not provided, it will use the predefined variation.
 * If textAlignment, textPlacement, or textVerticalAlignment are provided,
 * they will override the default alignment settings.
 * @param {string} textLocation 
 * @param {string} textAlignment 
 * @param {string} textPlacement 
 * @param {string} textVerticalAlignment 
 * @param {string} predefinedVariation 
 * @returns 
 */
var alignmentCardHandler = function alignmentCardHandler(textLocation, textAlignment, textPlacement, textVerticalAlignment, predefinedVariation) {
  var alignment = handler(textLocation, textAlignment, textPlacement, textVerticalAlignment, predefinedVariation);
  return {
    alignmentClass: alignment.getAlignment(),
    gridAlignmentClass: alignment.getGridAlignment(),
    textVerticalAlignmentClass: alignment.getVerticalAlignment()
  };
};
export default alignmentCardHandler;